import { Flex } from 'antd';
import { Billing as BillingModule } from '@modules/billing';
import styles from './billing.module.scss';

export const Billing = () => (
  <Flex className={styles.root} align="center" justify="center">
    <BillingModule />
  </Flex>
);
